import { createTheme } from "@mui/material/styles";

export const switchTheme = createTheme({
  components: {
    MuiSwitch: {
      styleOverrides: {
        track: {
          // Track colour
          // Unchecked
          backgroundColor: "var(--color-neutral-2)",
          // Checked
          ".Mui-checked.Mui-checked + &": {
            backgroundColor: "var(--color-neutral-2)",
          },
        },
        // Thumb colour
        switchBase: { color: "var(--color-neutral-1)" }, // unchecked
        colorPrimary: { "&.Mui-checked": { color: "var(--color-leano-1)" } }, // checked
      },
    },
  },
});
